import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import DateTitle from 'components/shared/DateTitle'
import { FormattedMessage } from 'react-intl'
import { sortDates } from 'helpers/helpers'
import BundleTicket from './tickets/BundleTicket'
import { useMemo } from 'react'
import { TicketBundleReservation } from 'store/selfcare-slice/types'

interface ManageTicketsBundlesProps {
    bundles: TicketBundleReservation[]
}

const ManageTicketsBundles = ({ bundles }: ManageTicketsBundlesProps) => {
    const bundlesDays = useMemo(
        () =>
            sortDates(
                Array.from(
                    new Set(
                        bundles.map(
                            (bundle) =>
                                bundle[
                                    `${bundle.changes ? 'changes' : 'original'}`
                                ].detail.date
                        )
                    )
                )
            ),
        [bundles]
    )
    const bundlesByDays = useMemo(
        () =>
            bundlesDays.map((day, index) => {
                const bundlesPerDay = bundles.filter(
                    (bundle) =>
                        bundle[`${bundle.changes ? 'changes' : 'original'}`]
                            .detail.date === day
                )

                return (
                    <Box gap={16} isFullWidth key={`bundle-${day}`}>
                        <DateTitle index={index + 1} date={day} />

                        {bundlesPerDay.map((bundle, bundleIndex) => (
                            <BundleTicket
                                bundle={bundle}
                                key={bundle.original.detail.orderBundleId}
                                index={index * 10 + bundleIndex}
                            />
                        ))}
                    </Box>
                )
            }),
        [bundlesDays, bundles]
    )

    return (
        <Section id="manage-bundles" hasSmallerSpacingsX hasSmallerSpacingsY>
            <Text variant="heading2" color="grayscale_900" mb={[24, 40]}>
                <FormattedMessage
                    id="selfcare.bundles.section_caption"
                    defaultMessage="Pakiety"
                />
            </Text>
            <Box gap={[24, 40]}>{bundlesByDays}</Box>
        </Section>
    )
}

export default ManageTicketsBundles
